<mat-icon [ngClass]="status ? 'linked' : 'unlinked'">radio_button_checked</mat-icon>